module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No human race is superior; no religious faith is inferior. All collective judgments are wrong. Only racists make them.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ELIE WIESEL")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A man’s reach should exceed his grasp, or what’s a heaven for?")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROBERT BROWNING")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 68
// module chunks = 0